"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogTableTitle = void 0;
var TableRow_1 = require("@mui/material/TableRow");
var styles_1 = require("@mui/material/styles");
var Table_1 = __importDefault(require("@mui/material/Table"));
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var DialogTableTitle = function (props) {
    var theme = (0, styles_1.useTheme)();
    return (react_1.default.createElement(material_1.Box, { sx: { backgroundColor: theme.palette.primary.light }, pl: 5, pr: 4, py: 2, display: "flex", alignItems: "center" },
        react_1.default.createElement(material_1.Typography, { variant: "h5", component: "div", sx: { py: theme.spacing(1.5) } }, props.title),
        props.children &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Box, { flexGrow: 1 }),
                props.children)));
};
exports.DialogTableTitle = DialogTableTitle;
var DialogTable = function (props) {
    return (react_1.default.createElement(material_1.TableContainer, null,
        react_1.default.createElement(DialogTableTable, { stickyHeader: true, size: "small" }, props.children)));
};
var DialogTableTable = (0, styles_1.styled)(Table_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-root svg.MuiSvgIcon-root")] = {
            color: theme.palette.grey[500],
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-colorError:hover svg.MuiSvgIcon-root")] = {
            color: theme.palette.error.main,
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " .MuiIconButton-colorPrimary:hover svg.MuiSvgIcon-root")] = {
            color: theme.palette.primary.main,
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " td:first-of-type, th:first-of-type")] = {
            paddingLeft: theme.spacing(5)
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " td:last-child, th:last-child")] = {
            paddingRight: theme.spacing(5)
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " &:last-child td")] = {
            border: 0,
        },
        _b[".".concat(TableRow_1.tableRowClasses.root, " svg.MuiSvgIcon-root")] = {
            fontSize: '0.8rem'
        },
        _b[".".concat(material_1.tableCellClasses.root)] = {
            fontSize: '14px'
        },
        _b[".".concat(material_1.tablePaginationClasses.root)] = {
            borderBottom: 'unset'
        },
        _b);
});
exports.default = DialogTable;
